<script lang="ts">
	import { onMount } from "svelte";
	import { createPromiseStore } from "../../../../core/utils/createPromiseStore";
	import listVouchersQuery from "../../appsync/queries/listVouchers.graphql";
	import { requestAll } from "../../appsync/requestAll";
	import { getGlobalSettings } from "../../getGlobalSettings";
	import { getClients } from "../../appsync/getClients";
	import Preloader from "../Preloader.svelte";
	import type { Voucher, VoucherListParams } from "../../../../core/schema/Voucher";
	import VoucherCard from "./VoucherCard.svelte";

	const globalSettings = getGlobalSettings();

	let vouchers: Voucher[] = [];

	const listVouchers = createPromiseStore(async () => {
		const { graphQL } = await getClients(globalSettings);
		return await requestAll<Voucher, VoucherListParams>(graphQL, {
			query: listVouchersQuery,
		});
	});

	$: loading = $listVouchers.status === "loading";

	onMount(async () => {
		vouchers = (await listVouchers.call()).sort((a, b) =>
			new Date(a.validTo).getTime() > new Date(b.validTo).getTime() ? 1 : -1,
		);
	});

	// eslint-disable-next-line no-warning-comments
	// FIXME remove this after upgrade to Svelte 5.
	/* eslint-disable @typescript-eslint/explicit-function-return-type */
</script>

<div class="w-full">
	<p class="text-md font-bold md:text-lg">Poukazy k uplatnění – {loading ? "" : ` ${vouchers.length}`}</p>

	{#if loading}
		<Preloader />
	{:else}
		<div class="mt-4 flex flex-col gap-6 md:mt-6">
			{#each vouchers as voucher}
				<VoucherCard {voucher} />
			{:else}
				Nemáte žádné poukazy k uplatnění.
			{/each}
		</div>
	{/if}
</div>
